(function () {
  var ATTRIBUTION_PARAM_KEYS = [
    'gclid',
    'gbraid',
    'wbraid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_id',
    'fbclid',
    'msclkid',
    'ttclid',
    'li_fat_id',
    'gad_source'
  ];

  var TRACKED_PATHS = [
    '/pages/ring-finder-quiz',
    '/pages/ring-builder',
    '/pages/consultation',
    '/pages/engagement-ring-finder'
  ];

  function isTrackedLink(href) {
    if (!href || href.charAt(0) === '#') return false;
    try {
      var path = new URL(href, window.location.origin).pathname;
      return TRACKED_PATHS.some(function (tracked) {
        return path === tracked || path.indexOf(tracked + '/') === 0;
      });
    } catch (error) {
      return false;
    }
  }

  function getPageParams() {
    return new URLSearchParams(window.location.search);
  }

  function mergeAttributionParams(targetUrl, sourceParams) {
    var url = new URL(targetUrl, window.location.origin);

    ATTRIBUTION_PARAM_KEYS.forEach(function (key) {
      if (sourceParams.has(key)) {
        url.searchParams.set(key, sourceParams.get(key));
      }
    });

    sourceParams.forEach(function (value, key) {
      if (key.indexOf('utm_') === 0 && !url.searchParams.has(key)) {
        url.searchParams.set(key, value);
      }
    });

    return url;
  }

  function getSelectedVariantId() {
    var pageParams = getPageParams();
    var urlVariant = pageParams.get('variant');
    if (urlVariant) return urlVariant;

    var variantInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]:not([disabled]), product-form input[name="id"]:not([disabled])'
    );
    if (variantInput && variantInput.value) return variantInput.value;

    var card = document.getElementById('ring-finder-cta');
    if (card && card.getAttribute('data-variant-id')) {
      return card.getAttribute('data-variant-id');
    }

    return null;
  }

  function syncRingFinderVariant() {
    var variantId = getSelectedVariantId();
    if (!variantId) return;

    var card = document.getElementById('ring-finder-cta');
    if (card) {
      card.setAttribute('data-variant-id', variantId);
    }
  }

  function updateTrackedLinks() {
    var pageParams = getPageParams();
    var variantId = getSelectedVariantId();

    syncRingFinderVariant();

    document.querySelectorAll('a[href]').forEach(function (link) {
      if (!isTrackedLink(link.getAttribute('href'))) return;

      var url = mergeAttributionParams(link.href, pageParams);

      if (variantId) {
        if (
          url.pathname.indexOf('/pages/ring-finder-quiz') === 0 ||
          url.pathname.indexOf('/pages/ring-builder') === 0 ||
          url.pathname.indexOf('/pages/engagement-ring-finder') === 0
        ) {
          url.searchParams.set('settingVariantId', variantId);
          var card = document.getElementById('ring-finder-cta');
          if (card && card.getAttribute('data-product-id')) {
            url.searchParams.set('settingId', card.getAttribute('data-product-id'));
          }
        }
      }

      link.href = url.toString();
    });
  }

  function initFaq() {
    document.querySelectorAll('.primo-faq__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        var panel = trigger.closest('.primo-faq__item').querySelector('.primo-faq__panel');
        trigger.setAttribute('aria-expanded', String(!isOpen));
        if (panel) panel.hidden = isOpen;
      });
    });
  }

  function bindVariantSync() {
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target) return;

      if (
        target.name === 'id' ||
        target.closest('.product-form__input') ||
        target.closest('variant-radios') ||
        target.closest('.productView-variants')
      ) {
        window.setTimeout(updateTrackedLinks, 0);
      }
    });

    var variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      variantRadios.addEventListener('change', updateTrackedLinks);
    }

    window.addEventListener('popstate', updateTrackedLinks);
  }

  function relocateTrustStrip() {
    var strip = document.querySelector('.gs-product__trust-strip');
    if (!strip || strip.dataset.gsRelocated === 'true') return;

    var node = strip.closest('.productView-moreItem') || strip;

    var tabAnchor =
      document.querySelector('.productView-tab') ||
      document.querySelector('.productView-tabs') ||
      document.querySelector('.halo-productView-tab') ||
      document.querySelector('[class*="productView-tab"]');

    var productTop = document.querySelector('.productView-top');
    var host = productTop && productTop.parentNode;

    if (tabAnchor && tabAnchor.parentNode) {
      tabAnchor.parentNode.insertBefore(node, tabAnchor);
      node.dataset.gsRelocated = 'true';
      strip.dataset.gsRelocated = 'true';
      return;
    }

    if (host) {
      host.insertBefore(node, productTop.nextSibling);
      node.dataset.gsRelocated = 'true';
      strip.dataset.gsRelocated = 'true';
    }
  }

  function init() {
    relocateTrustStrip();
    updateTrackedLinks();
    bindVariantSync();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
